import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

export const ConfirmationDialog = ({ open, onClose, callback, title, contentText, okBtnTitle = "Ok", cancelBtnTitle = "Отмена" }) => {
	return (
		<Dialog onClose={onClose} open={open}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<DialogContentText
					sx={{
						fontSize: "14px",
						minWidth: "300px",
					}}
				>
					{contentText}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button size="small" onClick={onClose}>
					{cancelBtnTitle}
				</Button>
				<Button size="small" autoFocus onClick={() => callback?.()}>
					{okBtnTitle}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
